import { useEffect } from "react";

/**
 * Injects Google Analytics 4 and Meta Pixel scripts when env vars are set.
 * Reads:
 *   - REACT_APP_GA4_MEASUREMENT_ID  (e.g. "G-XXXXXXXXXX")
 *   - REACT_APP_META_PIXEL_ID       (e.g. "123456789012345")
 * If either is missing/empty, the corresponding tracker is a no-op.
 */
const Tracking = () => {
  const ga4Id = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  const metaPixelId = process.env.REACT_APP_META_PIXEL_ID;

  useEffect(() => {
    // ---- Google Analytics 4 ----
    if (ga4Id && !document.getElementById("ga4-script")) {
      const script1 = document.createElement("script");
      script1.id = "ga4-script";
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
      document.head.appendChild(script1);

      const script2 = document.createElement("script");
      script2.id = "ga4-init";
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', '${ga4Id}', { anonymize_ip: true });
      `;
      document.head.appendChild(script2);
    }

    // ---- Meta Pixel ----
    if (metaPixelId && !document.getElementById("meta-pixel-script")) {
      const script = document.createElement("script");
      script.id = "meta-pixel-script";
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${metaPixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1" />`;
      document.body.appendChild(noscript);
    }
  }, [ga4Id, metaPixelId]);

  return null;
};

export default Tracking;
